import { AlertOctagon } from "lucide-react";

export function ReportManualReview({ reasons }) {
  return (
    <section className="report-manual-review overflow-hidden rounded-sm border-2 border-destructive bg-destructive-soft p-5">
      <div className="flex items-start gap-3">
        <AlertOctagon className="mt-0.5 h-5 w-5 shrink-0 text-destructive" />
        <div>
          <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-destructive">
            Manual Review Required
          </p>
          <h3 className="mt-1 font-display text-lg font-medium leading-tight text-foreground">
            Automated scoring has been suspended.
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground/85">
            Do not act on the categorisation below without a guided review by a qualified NDIS
            consultant.
          </p>
        </div>
      </div>
      <ul className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
        {reasons.map((r) => (
          <li
            key={r}
            className="flex items-start gap-2 rounded-sm border border-destructive/20 bg-card p-2 text-[13px] leading-relaxed text-foreground"
          >
            <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-destructive" />
            {r}
          </li>
        ))}
      </ul>
    </section>
  );
}
